<!-- @veltra/icons generated sha256:3119b869323f6eb0 gen:8 source:src/svg/normal/circle-plus.svg -->
<script setup lang="ts">
defineOptions({ name: 'CirclePlus' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8m3.012.5H7.5v2.488c0 .277.228.512.496.512a.513.513 0 0 0 .504-.512V8.5h2.488a.51.51 0 0 0 .512-.496.513.513 0 0 0-.512-.504H8.5V5.012a.51.51 0 0 0-.496-.512.513.513 0 0 0-.504.512V7.5H5.012a.51.51 0 0 0-.512.496c0 .276.235.504.512.504"
    />
  </svg>
</template>
